import { keys, reduce, isNil, isEmpty } from 'lodash';
import { Helpers, Validations } from '@utils/helpers';
import { IError } from '@utils/useForm';
import {  CoverageForm } from '@models/SIO/Coverage.model';

export const validate = (values: CoverageForm) => {
  const fields = keys(values);
  const errors: any = reduce(fields, (result, field: string) => {
    return { ...result, [field]: validateField(values, field) };
  }, {});
  return errors;
}

export const validateField = (values: any, name: string) => {
  const value = values[name];
  let error: IError | undefined = { isValid: true };
  switch (name) {
    case 'sumAssured':
      if (isNil(value)) {
        error = { isValid: false };
      } else {
        if (isEmpty(value)) {
          error = { isValid: false, message: `This field cannot be empty` };
        } else {
          const minPlanAssured = 150000, maxPlanAssured = 500000, dividendSumAssured = 1000;
          const planSumAssured = Number(value);
          const isOutOfAssured = Validations.isInRange(planSumAssured, minPlanAssured, maxPlanAssured);
          if (isOutOfAssured !== 0) {
            error = { isValid: false, message: `Please enter Sum Assured from ${Helpers.toCurrencyND(minPlanAssured)} to ${Helpers.toCurrencyND(maxPlanAssured)}` }
          } else {
            if (!Validations.isDivisible(planSumAssured, dividendSumAssured)) {
              error = { isValid: false, message: `Please enter Sum Assured  in multiples of S$${dividendSumAssured}` }
            }
          }
        }
      }

      break;
    case 'planPremiumMode':
      if (isNil(value)) {
        error = { isValid: false };
      }
      break;
    case 'illnessCover':
      if (!isEmpty(value)) {
        const minIllnessCover = 50000, maxIllnesssCover = 350000, dividendIllnessCover = 1000;
        const illnessCover = Number(value);
        const isOutOfIllnessCorver = Validations.isInRange(illnessCover, minIllnessCover, maxIllnesssCover);
        if (value > Number(values['sumAssured']) && values['sumAssured']) {
          error = { isValid: false, message: `Please enter an amount from ${Helpers.toCurrencyND(minIllnessCover)} to Max Amount ${Helpers.toCurrencyND(Number(values['sumAssured']))} ` }
        } else {
          if (isOutOfIllnessCorver !== 0) {
            error = { isValid: false, message: `Please enter an amount from ${Helpers.toCurrencyND(minIllnessCover)} to ${Helpers.toCurrencyND(maxIllnesssCover)}` }
          } else {
            if (!Validations.isDivisible(illnessCover, dividendIllnessCover)) {
              error = { isValid: false, message: `Please enter an amount in multiples of S$${dividendIllnessCover}` }
            }
          }
        }
      }

      break;
    case 'accidentCover':
      if (!isEmpty(value)) {
        const minAccidentCover = 100000, maxAccidentCover = 500000, dividendAccidentCover = 50000;
        const accidentCover = Number(value);
        const isOutOfAccidentCorver = Validations.isInRange(accidentCover, minAccidentCover, maxAccidentCover);
        if (isOutOfAccidentCorver !== 0) {
          error = { isValid: false, message: `Please enter an amount from ${Helpers.toCurrencyND(minAccidentCover)} to ${Helpers.toCurrencyND(maxAccidentCover)}` }
        } else {
          if (!Validations.isDivisible(accidentCover, dividendAccidentCover)) {
            error = { isValid: false, message: `Please enter an amount in multiples of S$${dividendAccidentCover}` }
          }
        }
      }
      break;
    case 'promoCode':
      // Hardcoded
      break;
  }
  return error;
}

export const validatePromoCode = (code: string): boolean => {
  return !isEmpty(code) && (code === 'SIO1' || code === 'SIO3')
}